import src from "IMAGE";
export default { src, width: 335, height: 137, blurWidth: 0, blurHeight: 0};
